import React, { FC } from 'react'

export const SVGArrowRight:FC = () => {

    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.5894 3.57709C10.264 3.25165 9.73634 3.25165 9.41091 3.57709C9.08547 3.90252 9.08547 4.43016 9.41091 4.7556L13.8217 9.16634H4.16683C3.70659 9.16634 3.3335 9.53944 3.3335 9.99968C3.3335 10.4599 3.70659 10.833 4.16683 10.833H13.8217L9.41091 15.2438C9.08547 15.5692 9.08547 16.0968 9.41091 16.4223C9.73634 16.7477 10.264 16.7477 10.5894 16.4223L16.4228 10.5889C16.7482 10.2635 16.7482 9.73586 16.4228 9.41042L10.5894 3.57709Z" fill="black"/>
    </svg>;
};
